import React from 'react';
import RegistrationWizard from '../components/registration/RegistrationWizard';
import { FULL_PAGE, SpinnerWrapper } from '../components/SpinnerWrapper';

const Main = () => (
  <>
    <SpinnerWrapper name={FULL_PAGE} />
    <RegistrationWizard />
  </>
);

export default Main;